import { SubPartnerAccount } from 'vopay';

/**
 * earthnode's `VIOAPIHelper::PENDING_STATUSES`: the onboarding stages in which a not-yet-active
 * partner account may still call its own `PENDING_PARTNER` routes. Outside them (Rejected, Disabled,
 * a stage the list does not name, or no recorded stage) the route answers RESOURCE_INACTIVE, so the
 * read is not attempted. A parent-scoped read would make this list unnecessary (ID-13788 follow-up).
 */
const PENDING_PARTNER_STATUSES = [
  'Application Pending',
  'Agreement Pending',
  'Awaiting Payment',
  'Payment Received',
  'Pre-Application Check',
  'Underwriting Review',
  'Finance Review',
  'Pending Sandbox Approval',
  'Account Provisioning',
  'Credit Risk Review',
  'Certification Pending',
  'Sales Manager Approval',
];

type PartnerReadability = Pick<SubPartnerAccount, 'IsActive' | 'AccountStatus'>;

/** `GET /partner/extended-info` authenticates as `PENDING_PARTNER`. */
export function canReadPartnerExtendedInfo({ IsActive, AccountStatus }: PartnerReadability): boolean {
  return IsActive || PENDING_PARTNER_STATUSES.includes(AccountStatus ?? '');
}

/** `GET /partner/webhook-url/info` authenticates as `PARTNER`, which requires an Active account. */
export function canReadPartnerWebhooks({ IsActive }: PartnerReadability): boolean {
  return IsActive;
}

/** `GET /partner/account/transactions` authenticates as `PARTNER`, which requires an Active account. */
export function canReadPartnerTransactions({ IsActive }: PartnerReadability): boolean {
  return IsActive;
}

/** `GET /partner/account` and its `status-summary` authenticate as `PARTNER`, which requires an Active account. */
export function canReadPartnerAccounts({ IsActive }: PartnerReadability): boolean {
  return IsActive;
}
